import React from 'react';
import styled from 'styled-components';

import { Box } from '../Box';
import { Icons } from '../Icons';
import { Skeleton } from '../Skeleton';

const StyledIconWrapper = styled(Box)`
  transform: rotate(90deg);
`;

type LoadingStateCardProps = {
  width: string;
};

const LoadingStateCard = ({ width = '324px' }: LoadingStateCardProps) => (
  <Box
    width={width}
    height="156px"
    backgroundColor="white"
    borderPosition={['all']}
    borderColor="grey-light-100"
    borderRadius={4}
    display="flex"
    flexDirection="column"
    justifyContent="space-between"
    pt={8}
    pl={6}
    pb={8}
    pr={5}
    aria-label="card loading state"
  >
    <Box display="flex" alignItems="center" justifyContent="space-between">
      <Skeleton width="164px" height="6px" />
      <StyledIconWrapper>
        <Icons.Overflow color="grey" />
      </StyledIconWrapper>
    </Box>
    <Box display="flex" flexDirection="column" flexGap="42px">
      <Skeleton width="60px" height="6px" />
      <Skeleton width="156px" height="6px" />
    </Box>
  </Box>
);

export { LoadingStateCard };
